module.exports = __webpack_public_path__ + "src/img/artist/name03.svg?d63c1304057b85b4ad916d4df65c0076";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/name03.svg
// module id = 139
// module chunks = 0